/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconArrowLeftUturnSquare(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 21 21"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.08 15.31a.6.6 0 1 1 0-1.2h5.381a2.713 2.713 0 0 0 2.707-2.707v-.077a2.713 2.713 0 0 0-2.707-2.706H6.906l1.631 1.628a.6.6 0 1 1-.847.849L5.04 8.452a.6.6 0 0 1-.001-.849l2.645-2.65a.6.6 0 0 1 .85.848L6.916 7.42h4.544a3.913 3.913 0 0 1 3.907 3.906v.077a3.913 3.913 0 0 1-3.907 3.906z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.116 1.993h-12a2.8 2.8 0 0 0-2.8 2.8v12a2.8 2.8 0 0 0 2.8 2.8h12a2.8 2.8 0 0 0 2.8-2.8v-12a2.8 2.8 0 0 0-2.8-2.8m-12-1.2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-12a4 4 0 0 0-4-4z"
        clipRule="evenodd"
      />
    </svg>
  );
}
